import React, { useState } from 'react';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import downloadIcon from "../../../../Assets/icons/download.svg";
import "./bulkUpload.scss";
import axiosInstance from '../../../services/api/API';
import Swal from 'sweetalert2';
import { REACT_APP_API_BASE_URL } from '../../../../constants/CommonAPI';
import * as XLSX from 'xlsx';

const LeadUpload = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [successRows, setSuccessRows] = useState([]); // Array to hold successful records
  const [failedRows, setFailedRows] = useState([]); // Array to hold failed records
  const [uploadedHeaders, setUploadedHeaders] = useState([]); // Array to hold uploaded file headers
  const token = localStorage.getItem('authToken');

  // const handleFormSubmit = async (formData) => {
  //   try {
  //     const formDataToSend = new FormData();
  //     formDataToSend.append('uploadFile', formData.uploadDocument);

  //     const response = await axiosInstance.post("/presale/bulkUpload", formDataToSend, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     const { errors, success } = response.data.data;

  //     // Update state with success and failed records
  //     setSuccessRows(success);
  //     setFailedRows(errors);
  //   } catch (error) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Failed to upload file. Please try again.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   }
  // };

  const handleFormSubmit = async (formData) => {
    try {
      const formDataToSend = new FormData();
      formDataToSend.append('uploadFile', formData.uploadDocument);
  
      // Upload file via API
      const response = await axiosInstance.post("/presale/bulkUpload", formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      });
  
      const { errors, success } = response.data.data;
  
      // Update state with success and failed records
      setSuccessRows(success);
      setFailedRows(errors);
  
      // Success Alert
      Swal.fire({
        title: "File Uploaded",
        text: `File uploaded successfully with ${success.length} successful rows and ${errors.length} failed rows.`,
        icon: "success",
        confirmButtonText: "OK",
      });
      
    } catch (error) {
      // Error Alert
      Swal.fire({
        title: "Error",
        text: "Failed to upload file. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  
  const readCSVFile = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const rows = data.split('\n').map(row => row.split(','));
      setUploadedHeaders(rows[0]); // Save headers for downloading successful records
      callback(rows);
    };
    reader.readAsText(file); // Read as text for CSV
  };

  const downloadRowsCSV = (rows, headers, filename) => {
    // Ensure rows is an array of arrays
    if (!Array.isArray(rows) || !rows.every(row => Array.isArray(row))) {
      console.error("Invalid data format for CSV download:", rows);
      return;
    }

    const finalData = [headers, ...rows];
    const csvContent = finalData.map(row => row.join(',')).join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename); // Set the download file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadFailedRowsCSV = (uploadedFile, failedRows) => {
    readCSVFile(uploadedFile, (csvData) => {
      const headers = [...csvData[0], 'ErrorMessage'];

      const failedRowsData = failedRows.map(errorRow => {
        const originalRow = csvData[errorRow.lineNumber] || [];
        const errorMessage = errorRow.message || "Error";
        return [...originalRow, errorMessage]; 
      });
      downloadRowsCSV(failedRowsData, headers, 'failed_records.csv'); // Trigger download
    });
  };

  const downloadSuccessRowsCSV = (uploadedFile, successRows) => {
    readCSVFile(uploadedFile, (csvData) => {
      const headers = [...csvData[0]];

      const successRowsData = successRows.map(successRow => {
        return csvData[successRow.lineNumber] || [];
      });

      downloadRowsCSV(successRowsData, headers, 'success_records.csv'); // Trigger download
    });
  };

  const UploadInputs = [
    {
      name: "uploadDocument",
      label: "Lead Upload ",
      type: "uploadFile",
      required: true,
      validation: { accept: ["csv"] }, // Ensure only CSV files can be uploaded
      gridClass: "col-lg-4",
    },
  ];

  return (
    <div className='p-5'>
      <div className='form-container' style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", gap: "10px", alignItems: "center" }}>
        <DynamicForm
          formConfig={UploadInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
        <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "20px" }}>
          <div className='downloadiconwrapper'>
            <a className='downloadHeading' href={`${REACT_APP_API_BASE_URL}/presale/downloadbulkUploadsample`}>Download File Sample</a>
            <img src={downloadIcon} alt='download' className="downloadImg" />
          </div>
          <button className="submit-btnn" onClick={() => handleFormSubmit(formData)} disabled={!formData.uploadDocument}>Submit</button>
          <div className="result-section d-flex justify-content-between gap-3">
        {successRows.length > 0 && (
          <div className="result-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ color: 'green' }}>Success Records: {successRows.length}</span>
              <img src={downloadIcon} alt='download' className="downloadImg" onClick={() => downloadSuccessRowsCSV(formData.uploadDocument, successRows)} style={{ cursor: 'pointer' }} />
            </div>
          </div>
        )}
        {failedRows.length > 0 && (
          <div className="result-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ color: 'red' }}>Failed Records: {failedRows.length}</span>
              <img src={downloadIcon} alt='download' className="downloadImg" onClick={() => downloadFailedRowsCSV(formData.uploadDocument, failedRows)} style={{ cursor: 'pointer' }} />
            </div>
          </div>
        )}
      </div>
        </div> 
      </div>
     
    </div>
  );
};

export default LeadUpload;
